import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=b491c6c0&scoped=true"
import script from "./PaySuccess.vue?vue&type=script&lang=js"
export * from "./PaySuccess.vue?vue&type=script&lang=js"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=b491c6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b491c6c0",
  null
  
)

export default component.exports